// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__9iO51","amount":"Amount_amount__3eg95","tip":"Amount_tip__3fSzM","tipHeader":"Amount_tipHeader__26Wur","tipsWrap":"Amount_tipsWrap___ai0I"};